import { Alert, AlertIcon, Box, FormControl, FormErrorMessage, Textarea } from "@chakra-ui/react";
import { REASON_PLACEHOLDER, type ReasonVariantProps } from "./types";

// Required "reason for change" field shown on the Creator/Work edit screens.
// Styled as the design system's info Alert — calm, on-brand, signals the edit
// is audited. (Was briefly a 4-arm A/B experiment; info_alert won.)
export default function ReasonField({ value, onChange, isInvalid }: ReasonVariantProps) {
  return (
    <Alert status="info" borderRadius="md" alignItems="flex-start" flexDirection="column" gap={2}>
      <Box display="flex" alignItems="center" fontSize="sm" fontWeight="medium">
        <AlertIcon />
        Changes are logged — add a reason
      </Box>
      <FormControl isRequired isInvalid={isInvalid}>
        <Textarea
          size="sm"
          rows={2}
          bg="white"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={REASON_PLACEHOLDER}
        />
        <FormErrorMessage>A reason is required.</FormErrorMessage>
      </FormControl>
    </Alert>
  );
}
